import { render, staticRenderFns } from "./NEOrders.vue?vue&type=template&id=0dced9c6&lang=pug"
import script from "./NEOrders.vue?vue&type=script&lang=js"
export * from "./NEOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports